import { LoanAmtSVG, clearLoanSvg, dueTodaySVG, notSupllSVG } from "../../screens/stores/makeTansaction/CashTransactionComp";
import "./transactionInsightStyles.css";
import { BiAbacus } from "react-icons/bi";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const TransactionInsights = ({ closeInsight, transactionInsights }) => {
  const { user } = useSelector((state) => state.webStoreUser);
  useEffect(() => {
    let targetDive = document.querySelector(".insightsDiv");
    console.log(transactionInsights, "transactionInsights");

    setTimeout(() => {
      targetDive.style.transform = "translateY(0)";
    }, 100);

    return () => {
      targetDive.style.transform = "translateY(100%)";
    };
  }, []);
  return (
    <>
      <div onClick={() => closeInsight(false)} className='insightDWrapper'>
        <div onClick={(e) => e.stopPropagation()} className='insightsDiv'>
          <h3>Transactaction insights</h3>
          <div className=' insigDetai64'>
            <div>
              <span className='NotSOT45i'>{notSupllSVG}</span>
              <div>
                <p style={{ color: "rgba(25, 25, 25, 1)", fontSize: "0.87rem" }}>Not supplied</p>
                <p className='pNameur664'>{transactionInsights?.totalNotSupplied ? transactionInsights.totalNotSupplied : 0}</p>
              </div>
            </div>
            <div>
              <span style={{ backgroundColor: "rgba(255, 252, 245, 1)" }} className='NotSOT45i'>
                {dueTodaySVG}
              </span>
              <div>
                <p style={{ color: "rgba(25, 25, 25, 1)", fontSize: "0.87rem" }}>Credit due today</p>
                <p className='pNameur664'>{transactionInsights?.totalLoanDueToday ? transactionInsights.totalLoanDueToday : 0}</p>
              </div>
            </div>
            <div>
              <span style={{ backgroundColor: "rgba(246, 251, 246, 1)" }} className='NotSOT45i'>
                {clearLoanSvg}
              </span>
              <div>
                <p style={{ color: "rgba(25, 25, 25, 1)", fontSize: "0.87rem" }}>Cleared Credit</p>
                <p className='pNameur664'>
                  {/* {user.userCountryCurrencySymbol} {totalCLearedLoanToday} */}
                  {user.userCountryCurrencySymbol}

                  {transactionInsights?.totalClearedLoanToday ? transactionInsights.totalClearedLoanToday : 0}
                </p>
              </div>
            </div>
            <div>
              <span style={{ backgroundColor: "rgba(206, 153, 255, 0.1)" }} className='NotSOT45i'>
                {/* <BiAbacus size={30} color='rgba(138, 43, 226, 1)' /> */}
                {LoanAmtSVG}
              </span>
              <div>
                <p style={{ color: "rgba(25, 25, 25, 1)", fontSize: "0.87rem" }}>Amount on Credit</p>
                <p className='pNameur664'>
                  {/*  {totalBreakdown.loaned} */}
                  {user.userCountryCurrencySymbol}

                  {transactionInsights?.totalAmountOnLoanToday ? transactionInsights.totalAmountOnLoanToday : 0}
                </p>
              </div>
            </div>
            <div>
              <span style={{ backgroundColor: "rgba(236, 249, 255,0.5)" }} className='NotSOT45i'>
                <BiAbacus size={24} color='rgb(30, 144, 201)' />
              </span>
              <div>
                <p style={{ color: "rgba(25, 25, 25, 1)", fontSize: "0.87rem" }}>Paid Transaction</p>
                <p className='pNameur664'>
                  {/* {user.userCountryCurrencySymbol} {totalBreakdown.paid} */}
                  {user.userCountryCurrencySymbol}

                  {transactionInsights?.totalPaidAmount ? transactionInsights.totalPaidAmount : 0}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransactionInsights;
